import { render, staticRenderFns } from "./OpportunityDetail.vue?vue&type=template&id=b6899b06&scoped=true&"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetail.vue?vue&type=style&index=0&id=b6899b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6899b06",
  null
  
)

export default component.exports